import moment from "moment-timezone";
import { dateToUTC } from '../helpers/moment-ex';
import { WORK_TYPE } from "../constants";
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { showOverlay, toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { GEO_REGION_BULK_EDIT_SAVED, GEO_STORAGE_LOCATION_BULK_SAVED, RECORD_FOUND, FIELD_STATUS_UPDATED, DELETE_GEO_SHAPE, GEO_REGION_RESTORE, GEO_REGION_DELETE } from '../constants/messages';
import {
    GET_FIELD_WORK_WINDOW_REQUEST, GET_FIELD_WORK_WINDOW_SUCCESS, GET_FIELD_WORK_WINDOW_FAILURE,
    GET_FIELD_WORK_WINDOW_CANCEL, GET_WORK_WINDOW_CONFIG_REQUEST, GET_WORK_WINDOW_CONFIG_SUCCESS,
    GET_WORK_WINDOW_CONFIG_FAILURE, GET_REGIONS_LIST, SELECT_REGIONS, TOGGLE_WORKWINDOW,
    UPDATE_WORK_WINDOW_CONFIG, CLEAR_FIELD_WORK_WINDOWS, VISIBLE_WORKWINDOW,
    GET_GEO_STORAGE_LOCATION_REQUEST, GET_GEO_STORAGE_LOCATION, GET_GEO_STORAGE_REPORT_REQUEST, GET_GEO_STORAGE_REPORT,
    GET_GEO_FIELD_LIST_REQUEST, GET_GEO_FIELD_LIST, FIELD_LIST_REQUEST_ID, GET_GEO_WORKED_ACRES_REQUEST,
    GET_GEO_WORKED_ACRES, UPDATE_FIELD_WORK_STATUS_SUCCESS, GET_GEO_CROP_LIST, GET_REGIONS_DETAIL, GET_REGIONS_DETAIL_REQUEST,
    GEO_REGION_WORKED_DATE_REQUEST, GEO_REGION_WORKED_DATE, GEO_REGION_WORKED_EG_REQUEST, GEO_REGION_WORKED_EG, TARE_LOAD_CAPACITY,
    GEO_CONFIG,
    GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST,
    GET_LOGISTIC_GEO_STORAGE_REPORT,
    GEO_FIELD_REPORT_REQUEST,
    GEO_FIELD_REPORT
} from '../constants/action-types';
import { usePermission, isPlannedOrTodate, isToday } from '../helpers/common';

export const getRegionsList = (payload, farmId) => ({ type: GET_REGIONS_LIST, payload, farmId });

export const regionsDetailRequesting = () => ({ type: GET_REGIONS_DETAIL_REQUEST });

export const getRegionsDetail = (payload) => ({ type: GET_REGIONS_DETAIL, payload });

export const selectRegions = payload => ({ type: SELECT_REGIONS, payload });

export const geoStorageLocationRequest = payload => ({ type: GET_GEO_STORAGE_LOCATION_REQUEST, payload });

export const geoStorageLocationList = payload => ({ type: GET_GEO_STORAGE_LOCATION, payload });

export const geoStorageReportRequest = payload => ({ type: GET_GEO_STORAGE_REPORT_REQUEST, payload });

export const geoLogisticStorageReportRequest = payload => ({ type: GET_LOGISTIC_GEO_STORAGE_REPORT_REQUEST, payload });

export const geoStorageReportList = payload => ({ type: GET_GEO_STORAGE_REPORT, payload });
export const geoLogisticStorageReportList = payload => ({ type: GET_LOGISTIC_GEO_STORAGE_REPORT, payload });

export const geoFieldReportRequest = payload => ({ type: GEO_FIELD_REPORT_REQUEST, payload });

export const geoFieldReport = payload => ({ type: GEO_FIELD_REPORT, payload });

export const getWorkWindowConfigRequest = payload => ({ type: GET_WORK_WINDOW_CONFIG_REQUEST, payload });

export const getWorkWindowConfigSuccess = payload => ({ type: GET_WORK_WINDOW_CONFIG_SUCCESS, payload });

export const getWorkWindowConfigFailure = payload => ({ type: GET_WORK_WINDOW_CONFIG_FAILURE, payload });

export const getFieldWorkWindowRequest = payload => ({ type: GET_FIELD_WORK_WINDOW_REQUEST, payload });

export const getFieldWorkWindowSuccess = payload => ({ type: GET_FIELD_WORK_WINDOW_SUCCESS, payload });

export const getFieldWorkWindowFailure = shapeRefId => ({ type: GET_FIELD_WORK_WINDOW_FAILURE, payload: { shapeRefId } });

export const getFieldWorkWindowCancel = shapeRefId => {
    defaultAgent.cancel(`workwindow_${shapeRefId}`);
    return { type: GET_FIELD_WORK_WINDOW_CANCEL, payload: { shapeRefId } };
};

export const fieldListRequest = () => ({ type: GET_GEO_FIELD_LIST_REQUEST });

export const fieldList = (data) => ({ type: GET_GEO_FIELD_LIST, payload: data });

export const workedAcresRequest = () => ({ type: GET_GEO_WORKED_ACRES_REQUEST });

export const workedAcres = (data) => ({ type: GET_GEO_WORKED_ACRES, payload: data });

export const updateFieldWorkStatusSuccess = (data) => ({ type: UPDATE_FIELD_WORK_STATUS_SUCCESS, payload: data });

export const addRequestId = (requestId) => ({ type: FIELD_LIST_REQUEST_ID, requestId });

export const clearShapeInfo = () => ({ type: CLEAR_FIELD_WORK_WINDOWS });

export const updateWorkWindowConfig = (shapeRefId, config) =>
    ({ type: UPDATE_WORK_WINDOW_CONFIG, payload: { shapeRefId, config } });

export const toggleWorkWindow = (shapeRefId, toggle) =>
    ({ type: TOGGLE_WORKWINDOW, payload: { shapeRefId, toggle } });

export const visibleWorkWindow = (shapeRefId, visible) =>
    ({ type: VISIBLE_WORKWINDOW, payload: { shapeRefId, visible } });

export const CropList = payload => ({ type: GET_GEO_CROP_LIST, payload });

export const regionWorkedDateRequest = () => ({ type: GEO_REGION_WORKED_DATE_REQUEST });

export const regionWorkedDate = (payload) => ({ type: GEO_REGION_WORKED_DATE, payload });

export const regionWorkedEgRequest = () => ({ type: GEO_REGION_WORKED_EG_REQUEST });

export const regionWorkedEg = (payload) => ({ type: GEO_REGION_WORKED_EG, payload });

export const tareLoadTotal = (payload) => ({ type: TARE_LOAD_CAPACITY, payload });

export const setGeoConfig = (payload) => ({ type: GEO_CONFIG, payload })

export const deleteGeoShape = data => dispatch => {
    const { geo_shape_uuid, farm_id, range } = data;

    defaultAgent.put('/api/geo/shape/delete', { geo_shape_uuid }).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        }
        else {
            if (agentResult.code !== DELETE_GEO_SHAPE.code) return dispatch(toastError(agentResult.message));
            dispatch(toastSuccess(agentResult.message));
            return dispatch(getGeoRegionList(farm_id, true, range));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Farm work window config: ', ex.message);
        dispatch(toastError(ex.message));
    });
};

export const getWorkWindowConfig = farmId => dispatch => {
    const data = { farmId };
    const params = { farm_uuid: farmId };
    const requestId = `workwindow_config_${farmId}`;

    dispatch(getWorkWindowConfigRequest(data));
    defaultAgent.get('/api/geo/workwindow/configuration', params, { requestId }).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        }
        else if (agentResult.code === RECORD_FOUND.code) {
            dispatch(getWorkWindowConfigSuccess({ farmId, config: agentResult.data }));
        } else {
            dispatch(getWorkWindowConfigFailure(data));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Farm work window config: ', ex.message);
        dispatch(getWorkWindowConfigFailure(data));
        dispatch(toastError(ex.message));
    });
};

export const getFieldWorkWindow = (data, cb) => (dispatch, getState) => {
    const { shapeRefId } = data;
    const state = getState();

    const { rangeId, range } = state.analyze.searchParams;
    const { params, requestId, methodName } = getFieldParams(data, state);

    dispatch(getFieldWorkWindowRequest({ ...data, rangeId }));
    defaultAgent.post(`/api/farm/${methodName}`, params, { requestId, timeout: 10 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(getFieldWorkWindowFailure(shapeRefId));
                dispatch(toastError(agentResult.message));
                if (cb) cb(null);
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                const res = agentResult.data;
                const apiData = (methodName === "region-covered") ?
                    ((res && Array.isArray(res.data) && res.data.length > 0) ? res.data[0] : null) : res;
                const withData = (apiData && apiData.data) ? apiData : null;

                //withData.grid.worked.length
                const payload = {
                    workedAcres: 0,
                    todayWorkedAcres: 0,
                    isTodayAcres: false,
                    totalAcres: 0,
                    isDisplayAcres: false,
                    isPresentShape: (withData && withData.grid &&
                        Array.isArray(withData.grid.worked) && withData.grid.worked.length > 0),
                    startDate: null,
                    endDate: null
                };

                if (methodName === "region-covered" && withData) {
                    payload.isTodayAcres = isToday(range);

                    if (withData.data) {
                        const findData = withData.data;
                        payload.totalAcres = findData.total_hectares ? (findData.total_hectares * 2.47105) : 0;
                        if (findData.hasOwnProperty("linear_hectares")) {
                            payload.workedAcres = (findData.linear_hectares * 2.47105);
                            payload.isDisplayAcres = true;
                        } else if (findData.hasOwnProperty("worked_hectares")) {
                            payload.workedAcres = (findData.worked_hectares * 2.47105);
                        }
                    }

                    if (isToday(range) && withData.today_data) {
                        const findData = withData.today_data;
                        if (findData.hasOwnProperty("linear_hectares")) {
                            payload.todayWorkedAcres = (findData.linear_hectares * 2.47105);
                            payload.isDisplayAcres = true;
                        } else if (findData.hasOwnProperty("worked_hectares")) {
                            payload.todayWorkedAcres = (findData.worked_hectares * 2.47105);
                        }
                    }
                } else if (methodName === "area-covered") {
                    payload.isTodayAcres = isToday(range);

                    if (withData.data) {
                        const findData = withData.data;
                        if (findData.hasOwnProperty("linear_hectares")) {
                            payload.workedAcres = (findData.linear_hectares * 2.47105);
                            payload.isDisplayAcres = true;
                        } else if (findData.hasOwnProperty("worked_hectares")) {
                            payload.workedAcres = (findData.worked_hectares * 2.47105);
                        }
                    }

                    if (isToday(range) && withData.today_data) {
                        const findData = withData.today_data;
                        if (findData.hasOwnProperty("linear_hectares")) {
                            payload.todayWorkedAcres = (findData.linear_hectares * 2.47105);
                            payload.isDisplayAcres = true;
                        } else if (findData.hasOwnProperty("worked_hectares")) {
                            payload.todayWorkedAcres = (findData.worked_hectares * 2.47105);
                        }
                    }
                }

                if (withData && withData.range && withData.range.start && withData.range.end) {
                    payload.startDate = withData.range.start;
                    payload.endDate = withData.range.end;
                }

                dispatch(getFieldWorkWindowSuccess({ shapeRefId, data: payload }));
                if (cb) cb(apiData);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Geo shape work window: ', ex.message);
            dispatch(getFieldWorkWindowFailure(shapeRefId));
            dispatch(toastError(ex.message));
        });
};

const getFieldParams = (data, state) => {
    const fieldParams = {
        methodName: null,
        params: {},
        requestId: "workwindow"
    };

    const timezone = state.farm.currentFarm.timezone_identifier;
    const custom = state.analyze.searchParams.custom;
    const range = state.analyze.searchParams.range;

    const allow = usePermission();
    if (allow("geo-shape-config", "edit")) {
        const { shapeRefId, farmId } = data;
        const wwConfig = state.geo.workWindowConfigById[farmId];
        const farmConfiguration = wwConfig && wwConfig.configuration ? wwConfig.configuration : null;
        const defaultConfig = state.geo.defaultWorkWindowConfig;

        const startUTC = dateToUTC(custom.from, timezone);
        const endUTC = dateToUTC(custom.to, timezone);

        fieldParams.requestId = `workwindow_${shapeRefId}`;
        fieldParams.methodName = "area-covered";
        fieldParams.params = {
            ...defaultConfig,
            ...farmConfiguration,
            ...data.config,
            geo_shape_uuid: shapeRefId,
            start_date: startUTC.format(),
            end_date: endUTC.format()
        };
    }
    else {
        const startDate = isPlannedOrTodate(range) ?
            moment.utc().startOf("year") : moment.utc(custom.from).startOf("year");
        const endDate = isToday(range) || isPlannedOrTodate(range) ?
            undefined : moment.utc(custom.to).endOf("day");

        fieldParams.requestId = `workwindow_${data.shapeGroupId}`;
        fieldParams.methodName = "region-covered";
        fieldParams.params = {
            geo_region_uuid: data.shapeGroupId,
            work_type_id: data.workTypeId,
            include_grid: true,
            start_date: startDate ? startDate.format() : startDate,
            end_date: endDate ? endDate.format() : endDate
        };
    }

    return fieldParams;
};

export const saveRegion = (data, isNotify = true, range = {}) => dispatch => {
    return defaultAgent.post('/api/geo/region/save', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                if (agentResult.status === 'error') {
                    if (isNotify) {
                        dispatch(toastError(agentResult.message));
                    }
                }
                else {
                    if (isNotify) {
                        dispatch(toastSuccess(agentResult.message));
                        dispatch(getGeoRegionList(data.farm_uuid, true, range));
                    }
                }
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const saveRegionTitle = (data) => dispatch => {
    defaultAgent.post('/api/geo/region/save', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                if (agentResult.status === 'error')
                    dispatch(toastError(agentResult.message));
                // else dispatch(getGeoRegionList(data.farm_uuid, true));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getGeoRegionList = (farmId, includeRemoved = false, range) => dispatch => {
    const dateRange = range ? range : {};
    defaultAgent.get('/api/geo/region/list', { farm_uuid: farmId, include_work_status: true, include_removed: includeRemoved, ...dateRange })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(getRegionsList([], farmId));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data)
                dispatch(getRegionsList(agentResult.data, farmId));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getGeoRegionDetail = (data, includeRemoved = false, range) => dispatch => {
    const dateRange = range ? range : {};
    dispatch(regionsDetailRequesting())
    defaultAgent.get('/api/geo/region/list', { ...data, include_removed: includeRemoved, ...dateRange })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(getRegionsDetail([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data) {
                if (Array.isArray(agentResult.data)) {
                    const regions = {};
                    for (const item of agentResult.data) {
                        if (!item && !item.geo_region_uuid) continue;
                        regions[item.geo_region_uuid] = item;
                    }
                    dispatch(getRegionsDetail(regions));
                }
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getGeoFieldList = (params, cb) => dispatch => {
    const requestId = `field_list`;
    dispatch(addRequestId(requestId));
    dispatch(fieldListRequest());
    defaultAgent.get('/api/geo/region/list', { farm_uuid: params, include_work_status: true, geo_region_type_id: 2 }, { requestId: `geo_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(fieldList([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data) {
                dispatch(fieldList(agentResult.data));
                if (cb) cb();
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Geo shape field list data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldList([]));
        });
};

export const getWorkedAcres = (params) => (dispatch) => {
    const { farmId } = params;

    let reqParams = {
        farm_uuid: farmId,
    };
    dispatch(workedAcresRequest());
    const requestId = `shape_info_farm_summary_${farmId}`;
    dispatch(addRequestId(requestId));
    defaultAgent.post(`/api/farm/region-covered-summary`, reqParams, { requestId: `geo_${requestId}`, timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(workedAcres());
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(workedAcres(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Geo field list worked acres: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(workedAcres());
        });
};

export const updateFieldWorkStatus = (params, cb) => dispatch => {
    const reqParams = {
        farm_uuid: params.farm_uuid,
        work_status: params.work_status.map(e => {
            const { geo_shape_uuid, ...rest } = e;
            return rest;
        })
    };
    defaultAgent.put('/api/geo/shape/work-status', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === FIELD_STATUS_UPDATED.code) {
                dispatch(toastSuccess(agentResult.message));
                dispatch(updateFieldWorkStatusSuccess({
                    ...params, work_status: params.work_status
                }));
            } else dispatch(toastError(agentResult.message));
            cb && cb();
        }).catch(ex => {
            dispatch(toastError(ex.message));
            cb && cb();
        });
};

export const deleteRegions = (data, cb, range = {}) => dispatch => {
    dispatch(showOverlay({ text: `${data.is_inactivate ? 'Removing...' : 'Deleting...'}` }));
    const farmId = data.farm_uuid;
    defaultAgent.put('/api/geo/region/delete', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === GEO_REGION_DELETE.code) {
            dispatch(toastSuccess(agentResult.message));
            dispatch(getGeoRegionList(farmId, true, range));
        } else dispatch(toastError(agentResult.message));
        cb && cb();
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const activateRegion = (data, cb, range = null) => dispatch => {
    dispatch(showOverlay({ text: 'Restoring...' }));
    const farmId = data.farm_uuid;
    defaultAgent.put('/api/geo/region/activate', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === GEO_REGION_RESTORE.code) {
            dispatch(toastSuccess(agentResult.message));
            dispatch(getGeoRegionList(farmId, true, range));
        } else dispatch(toastError(agentResult.message));
        cb && cb();
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const saveBulkEditRegion = (data, cb) => dispatch => {
    defaultAgent.put('/api/geo/region/bulk/edit', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === GEO_REGION_BULK_EDIT_SAVED.code) {
            dispatch(toastSuccess(agentResult.message));
            if (cb) cb(true);
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(false);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb(false);
    });
};

export const getGeoStorageLocation = (params, cb) => dispatch => {
    if (!cb) dispatch(geoStorageLocationRequest(params));
    defaultAgent.get(`/api/geo/storage/list`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            dispatch(geoStorageLocationList({ ...params, data: agentResult.data }));
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};


export const getGeoStorageReport = (params, cb) => dispatch => {

    if (!cb) dispatch(geoStorageReportRequest(params));
    defaultAgent.get(`/api/geo/storage/report`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            dispatch(geoStorageReportList({ ...params, data: agentResult.data }));
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};
export const getLogisticGeoStorageReport = (params, cb) => dispatch => {

    if (!cb) dispatch(geoLogisticStorageReportRequest(params));
    defaultAgent.get(`/api/geo/storage/report`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            dispatch(geoLogisticStorageReportList({ ...params, data: agentResult.data }));
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};

export const getTotalTareInfo = (data, type) => dispatch => {

    let reqParams = {
        farm_uuid: data.farmId,
        range_type: data.range,
        from_date: data.fromDate,
        to_date: data.toDate,
        filter: 'last',
        is_tareload: true,
        region_uuid: data.region_uuid
    };

    defaultAgent.get(`/api/plan/load/v1/history?t=123`, reqParams).then(res => {
        const agentResult = apiResponse(res);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(tareLoadTotal({ data: agentResult.data, type, shapeId: data.shapeId }));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log('Tare Load Capacity Error: ', ex.message);
        dispatch(toastError(ex.message));
    });
}

export const getGeoConfig = params => dispatch => {
    defaultAgent.get(`/api/farm/settings`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setGeoConfig(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const geoStorageReport = (params, cb) => dispatch => {

    if (!cb) dispatch(geoStorageReportRequest(params));
    defaultAgent.post(`/api/geo/storage/report`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            if (agentResult && agentResult.data) {
                for (const geoShapeId of Object.keys(agentResult.data)) {
                    dispatch(geoStorageReportList({ ...params, data: agentResult.data[geoShapeId], geo_region_shape_uuid: geoShapeId }));
                }
            }
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};

export const getGeoFieldReport = (params, cb) => dispatch => {
    if (!cb) dispatch(geoFieldReportRequest(params));

    defaultAgent.post(`/api/geo/field/report`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            if (agentResult && agentResult.data) {
                dispatch(geoFieldReport({ data: agentResult.data }));
            }
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};

export const saveBulkStorageLocation = (data, cb) => dispatch => {
    defaultAgent.put('/api/geo/storage/bulk/save', data).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === GEO_STORAGE_LOCATION_BULK_SAVED.code) {
            dispatch(toastSuccess(agentResult.message));
            if (cb) cb(true);
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(false);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb(false);
    });
};

export const getGeoCropList = (params, cb) => dispatch => {
    defaultAgent.get(`/api/geo/region/crop/list`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            dispatch(CropList(agentResult.data));
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};

export const getGeoRegionWorkedDate = (params) => dispatch => {
    dispatch(regionWorkedDateRequest())
    defaultAgent.get(`/api/geo/region/worked-date`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(regionWorkedDate({
                geo_region_uuid: params.geo_region_uuid,
                date: agentResult.data
            }));
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getGeoRegionWorkedEg = (params) => dispatch => {
    dispatch(regionWorkedEgRequest())
    defaultAgent.post(`/api/geo/region/worked-date-range`, {
        geo_region_uuid: params.geo_region_uuid,
        start_date: params.start_date,
        end_date: params.end_date,
    }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            const result = agentResult.data;
            const workedData = result.hasOwnProperty('work_date_ranges') ? result.work_date_ranges : [];
            const workTypeId = WORK_TYPE[params.plan_type_id] ? WORK_TYPE[params.plan_type_id].work_type_id : 2;
            const filteredWork = workedData.find((e) => e.work_type_id === workTypeId);
            if (workedData.length > 0 && filteredWork) {
                let workedEg = filteredWork.worked_by_equipment_groups ? filteredWork.worked_by_equipment_groups : [];
                workedEg = workedEg.map((e) => ({ equipment_group_uuid: e.equipment_group_uuid }));
                dispatch(regionWorkedEg(workedEg));
            } else {
                defaultAgent.get(`/api/geo/region/worked-eg`, params).then(res => {
                    const agentResult = apiResponse(res, []);
                    if (agentResult.isUnauthorized) {
                        dispatch(toastError(agentResult.message));
                        dispatch(tokenExpired());
                    } else if (agentResult.data)
                        dispatch(regionWorkedEg(agentResult.data));
                    else if (agentResult.message) {
                        dispatch(toastError(agentResult.message));
                    }
                }).catch(ex => {
                    dispatch(toastError(ex.message));
                });
            }
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};
